import FlashLib from 'flashlib_onlyplay';
import animationTypes from '../animations/animationTypes';
import animationCreator from '../libs/game-engine/src/animations/animationCreator';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';
import { getRandom } from 'Engine/utils/getRandom';
import EntryPoint from 'Engine/EntryPoint';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../enums/eSounds';
import eBaseEventTypes from 'Engine/enums/eBaseEventTypes';

export default class ControllerCookieMan extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);

    this._animations = {
      IDLE: 'idle',
      BIG_WIN: 'big_win',
      NO_WIN: 'no_win',
      COIN: 'win_coin',
      ANTISIPATOR_START: 'antisipate_start',
      ANTISIPATOR_IDLE: 'antisipate_idle',
      ANTISIPATOR_END: 'antisipate_end',
    };

    this._sounds = {
      [this._animations.NO_WIN]: [eSounds.EST_COOKIE_FAIL],
      [this._animations.COIN]: [eSounds.EST_COOKIE_WIN],
      [this._animations.BIG_WIN]: [eSounds.EST_COOKIE_BIG_WIN_1, eSounds.EST_COOKIE_BIG_WIN_2],
    };

    this.initAnimation();
    this.addListeners();
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_SHOW_WIN_STATE__START, this.playRandomWin.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_FREESPIN_IN_STATE__START, this.playBigWin.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_OPEN_JACKPOT_BOXES__START, this.playRandomWin.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_REELS_STOPPED, this.tryToPlayFail.bind(this));
    // GlobalDispatcher.add(eBaseEventTypes.EBET_ANTISIPATOR__START, this.onStartAntisipator, this);
    // GlobalDispatcher.add(eBaseEventTypes.EBET_ANTISIPATOR__STOP, this.onStopAntisipator, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
  }

  initAnimation() {
    this.animation = animationCreator.createAnimation(animationTypes.COOKIE);
    this.animation.stateData.defaultMix = 0.2;
    this.animation.stateData.setMix(this._animations.IDLE, this._animations.ANTISIPATOR_START, 0);

    this.animation.state.setAnimation(0, this._animations.IDLE, true);
    this.addChild(this.animation);
  }

  onStartAntisipator() {
    this.animation.state.setAnimation(0, this._animations.ANTISIPATOR_START, false);
    this.animation.state.addAnimation(0, this._animations.ANTISIPATOR_IDLE, true, 0);
  }

  onStopAntisipator() {
    this.playAnimation(this._animations.ANTISIPATOR_END);
  }

  playRandomWin() {
    this.playAnimation([this._animations.BIG_WIN, this._animations.COIN][getRandom(0, 1)]);
  }

  playBigWin() {
    this.playAnimation(this._animations.BIG_WIN);
  }

  tryToPlayFail() {
    if (EntryPoint.GameModel.freespinsEnabled || EntryPoint.GameModel.totalWin) return;
    if (getRandom(1, 5) !== 1) return;

    this.playAnimation(this._animations.NO_WIN);
  }

  playAnimation(type) {
    this.playSound(type);
    this.animation.state.setAnimation(0, type, false);
    this.animation.state.addAnimation(0, this._animations.IDLE, true, 0);
  }

  playSound(type) {
    const availableSounds = this._sounds[type];
    if (!availableSounds) return;

    const sound = availableSounds[getRandom(0, availableSounds.length - 1)];
    SoundManager.play(sound.soundName, sound.volume, false, sound.group);
  }

  onGameResized(data) {
    if (data.isLandscape) {
      this.animation.scale.set(1);
      this.animation.x = 0;
      this.animation.y = 0;
    } else if (data.isMobile && data.isPortrait) {
      this.animation.scale.set(0.822);
      this.animation.x = 445;
      this.animation.y = -595;
    }
  }
}
